import React, { useEffect, useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Input, Row, Spin } from "antd";

import styles from "./styles/EstablishmentCategory.module.css";
import { createCategory } from "../../http-request/establishment-category";
import Notification from "../../../components/shared/Notification";
import { COLORS } from "../../../constants";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
);

const CategoryForm = ({ categories = [], reloadCategories = () => {} }) => {
  const [categoryList, setcategoryList] = useState([]);
  const [foundCategory, setfoundCategory] = useState();
  const [newCategory, setnewCategory] = useState();
  const [value, setValue] = useState("");
  const [isLoading, setisLoading] = useState(false);

  useEffect(() => {
    setcategoryList(categories);
  }, [categories]);

  const onChangeInput = (e) => {
    setValue(e.target.value);
    // test push
    const category =
      categoryList.length > 0 &&
      categoryList.find((item) => item.label === e.target.value.toUpperCase());
    if (!category) setfoundCategory(false);
    setfoundCategory(category);
    setnewCategory(e.target.value.toUpperCase());
  };

  const onSubmitEvent = async () => {
    if (!foundCategory) {
      setisLoading(true);
      await createCategory(newCategory)
        .then(() => {
          reloadCategories();
        })
        .finally(() => setisLoading(false));
    } else {
      Notification(
        "Error",
        "You can't add multiple value of the same category",
        "error"
      );
    }
    setValue("");
  };
  return (
    <>
      <Divider style={{ margin: "10px 0 10px" }} />
      <Row align="middle" gutter={5} className={styles.content}>
        <Col span={14}>
          <Input
            onChange={onChangeInput}
            value={value}
            placeholder="Please enter category"
          />
        </Col>
        <Col span={10}>
          <Button
            block
            type="primary"
            onClick={onSubmitEvent}
            icon={!isLoading && <PlusOutlined />}
            disabled={isLoading}
          >
            {isLoading ? <Spin indicator={antIcon} /> : "Add Category"}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CategoryForm;
